import { nodeAuthApi } from '~c/services';

/**
 * Hook to check if Microsoft authentication is enabled.
 * Fetches configuration from the backend via RTK Query (auto-deduplicates requests).
 */
export function useMicrosoftAuth() {
  const { data } = nodeAuthApi.useMicrosoftConfigQuery();

  return {
    isEnabled: !!(data?.clientId && data?.tenantId),
  };
}

export default useMicrosoftAuth;
